/**
 * Messages exchanged over `window.postMessage` between the session broker
 * (the app's `/session-broker` route, loaded in a hidden iframe) and the
 * embedding page on another W Social origin such as live.wsocial.eu.
 *
 * The broker only answers origins listed in `SESSION_BROKER_ALLOWED_ORIGINS`
 * and only ever hands out the short-lived access token. Refreshing stays the
 * broker's job: it rotates the refresh token itself and pushes the new access
 * token to the subscriber, so the embedding page never competes with the app
 * for the single-use refresh token.
 */

export const SESSION_BROKER_REQUEST = 'wsocial:session:request'
export const SESSION_BROKER_RESPONSE = 'wsocial:session'

/** Sent by the embedding page to (re)subscribe to session updates. */
export type SessionBrokerRequest = {
  type: typeof SESSION_BROKER_REQUEST
}

export type BrokeredSession = {
  did: string
  handle: string
  /** PDS base URL the access token is valid for. */
  service: string
  accessJwt: string
}

/**
 * Sent by the broker in reply to a request and again whenever the session
 * changes (token refresh, account switch, logout).
 */
export type SessionBrokerResponse = {
  type: typeof SESSION_BROKER_RESPONSE
  /** `null` when nobody is logged in on the app origin. */
  session: BrokeredSession | null
  /**
   * Present when the stored session exists but could not be refreshed, e.g.
   * the network is down. Distinguishes "logged out" from "temporarily
   * unavailable".
   */
  error?: 'refresh-failed'
}
